import { Link } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';
import InlineSVG from 'svg-inline-react';

import type { ThemeColorType } from 'src/styles/theme';

export const NextBestActionsContainer = styled.div<{ isDismissing: boolean }>`
  max-height: ${props => (props.isDismissing ? '0' : '350px')};
  margin-bottom: ${props => (props.isDismissing ? '0' : props.theme.space.s7)};
  transition: max-height 1s ease-in-out, margin 1s ease-in-out;

  ${props => props.theme.mediaQueries.smallDown} {
    margin-bottom: ${props => props.theme.space['2.8']};
  }
  .styled-card:not(:last-child) {
    margin-bottom: ${props => props.theme.space['2.0']};
    ${props => props.theme.mediaQueries.smallDown} {
      margin-bottom: 0;
    }
  }
`;

export const CloseButtonWrap = styled.div`
  width: 4.4rem;
  height: 4.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  position: absolute;
`;

export const CloseCardButton = styled(InlineSVG)`
  display: inline-block;
  width: ${props => props.theme.space.s3};
  height: ${props => props.theme.space.s3};
  svg {
    fill: #dfecea;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
    top: 0;
  }

  75% {
    opacity: 0;
  }

  100% {
    opacity: 0;
    top: 50px;
  }
`;
export const NBACapsuleCard = styled.div<{ color: ThemeColorType; isDismissing: boolean }>`
  position: relative;
  background-color: ${props => props.theme.colors[props.color]};
  border-radius: ${props => props.theme.radii.large};
  box-shadow: ${props => props.theme.shadows.dp12};
  overflow: hidden;
  animation: ${props => (props.isDismissing ? fadeOut : null)};
  animation-fill-mode: forwards;

  ${props => props.theme.mediaQueries.smallDown} {
    margin-bottom: 0;
  }
`;

export const StyledCard = styled.div<{ color: ThemeColorType; isDismissing: boolean }>`
  position: relative;
  background-color: ${props => props.theme.colors[props.color]};
  border-radius: ${props => props.theme.radii.large};
  padding: ${props => props.theme.space.s5};
  padding-bottom: ${props => props.theme.space.s4};
  cursor: pointer;
  animation: ${props => (props.isDismissing ? fadeOut : null)};
  animation-fill-mode: forwards;

  ${props => props.theme.mediaQueries.smallDown} {
    margin-bottom: 0;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Description = styled.div`
  color: white;
  font-size: ${props => props.theme.fontSizes.headerThree};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights['medium']};
  margin-bottom: ${props => props.theme.space.s5};
  padding-right: ${props => props.theme.space['4.0']};
`;

export const LinkContainer = styled.div`
  display: flex;
  margin: auto 0 ${props => props.theme.space.s5};
`;

export const StyledLink = styled(Link)<{ showUnderline: boolean }>`
  color: white !important;
  font-size: ${props => props.theme.fontSizes.headerFour};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights['book']};
  margin-right: ${props => props.theme.space.s2};
  text-decoration: ${props => (props.showUnderline ? 'underline' : 'none')} !important;
`;

export const ChevronIcon = styled(InlineSVG)`
  width: ${props => props.theme.space.s3};
  height: ${props => props.theme.space.s3};
  transform: rotate(270deg);
  position: relative;
  top: ${props => props.theme.space['0.5']};
`;

export const IconContainer = styled.div`
  background-color: ${props =>
    props.color === 'capsuleGreen60' ? props.theme.colors.capsuleGreen55 : 'rgba(255, 255, 255, 0.32)'};
  width: ${props => props.theme.space['6.0']};
  height: ${props => props.theme.space['6.0']};
  border-radius: ${props => props.theme.space['3.0']};
  padding: ${props => props.theme.space.s3};
  margin: auto;
  margin-right: 0;
  display: block;
`;

export const StyledIcon = styled.img`
  width: ${props => props.theme.space['3.6']};
  height: ${props => props.theme.space['3.6']};
`;

export const ImageRow = styled.div(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${props => props.theme.colors.capsuleGray00};
    height: 13.8rem;
  `
);

export const TextRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.space.s4} ${props => props.theme.space.s5};
`;
